import normalize, { userSchema } from 'schema';
import {
  REFRESH_TOKEN,
  REFRESH_TOKEN_SUCCESS,
  REFRESH_TOKEN_FAILURE,
  LOGIN,
  LOGIN_SUCCESS,
  LOGOUT,
  SEND_PASSWORD_RESET_EMAIL,
  SEND_PASSWORD_RESET_EMAIL_SUCCESS,
  UPDATE_PASSWORD,
  UPDATE_PASSWORD_SUCCESS,
} from 'actionTypes';

export function refreshToken(token) {
  return {
    type: REFRESH_TOKEN,
    payload: {
      token,
    },
  };
}

export function refreshTokenSuccess(response) {
  return {
    type: REFRESH_TOKEN_SUCCESS,
    token: response.payload.token,
  };
}

export function refreshTokenFailure(response) {
  return {
    type: REFRESH_TOKEN_FAILURE,
  };
}

export function login(email, password) {
  return {
    type: LOGIN,
    payload: {
      email,
      password,
    },
  };
}

export function loginSuccess(response) {
  return {
    type: LOGIN_SUCCESS,
    normalizedData: normalize(response.payload, userSchema),
    token: response.payload.token,
  };
}

export function logout() {
  return {
    type: LOGOUT,
  };
}

export function sendPasswordResetEmail(email) {
  return {
    type: SEND_PASSWORD_RESET_EMAIL,
    payload: {
      email,
    },
  };
}

export function sendPasswordResetEmailSuccess() {
  return {
    type: SEND_PASSWORD_RESET_EMAIL_SUCCESS,
  };
}

export function updatePassword(token, password) {
  return {
    type: UPDATE_PASSWORD,
    payload: {
      reset_token: token,
      password,
    },
  };
}

export function updatePasswordSuccess(response) {
  return { type: UPDATE_PASSWORD_SUCCESS };
}



// WEBPACK FOOTER //
// ./src/actions/authActions.js